/**
 * KAN-925: выход аккаунта отзывает его refresh на backend (POST /api/v1/auth/logout/,
 * refresh попадает в blacklist). Чистый axios с access этого аккаунта, а не
 * apiClient: запрос не должен уйти с токеном активного аккаунта и не должен
 * запускать refresh по 401. Best effort: ошибка (сеть, протухший access) выходу не мешает.
 */
import axios from 'axios';
import { API_BASE_URL } from './baseUrl';

export const LOGOUT_URL = '/api/v1/auth/logout/';

export function revokeRefreshToken(access: string, refresh: string | null): void {
  if (!refresh) return;
  try {
    axios
      .post(`${API_BASE_URL}${LOGOUT_URL}`, { refresh }, { headers: { Authorization: `Bearer ${access}` } })
      .catch(() => {
        // выход уже случился локально
      });
  } catch {
    // axios недоступен (тесты с моками): выход локально всё равно состоялся
  }
}
